import { render, staticRenderFns } from "./LandlordAddTenant.vue?vue&type=template&id=be857622&scoped=true&"
import script from "./LandlordAddTenant.vue?vue&type=script&lang=js&"
export * from "./LandlordAddTenant.vue?vue&type=script&lang=js&"
import style0 from "./LandlordAddTenant.vue?vue&type=style&index=0&id=be857622&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "be857622",
  null
  
)

export default component.exports